// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Pg_2_13_avatarContainer__u8g1K","avatarWrap":"Pg_2_13_avatarWrap__wWjxU"};